import axios from 'axios';
import Vue from 'vue';
import router from '../routers/router';
import store from '../store/store';
import moment from 'moment';

Vue.prototype.$tempoMaxSessao = 1;


function ifAtualizarToken() {

    /*Hora do login + tempo se Sessão*/
    var horaFinalLogin = moment(store.getters.horaFinalSessao,"YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
    var horaAtual = moment().format("YYYY-MM-DD HH:mm:ss");

    /*Hora do horaUltimoEvento + tempo se Sessão*/
    let horaFinalEvento = moment(store.getters.horaUltimoEvento,"YYYY-MM-DD HH:mm:ss").add(Vue.prototype.$tempoMaxSessao, "h").format("YYYY-MM-DD HH:mm:ss");
    if (moment(horaAtual).isAfter(horaFinalLogin)) {
        if (moment(horaAtual).isBefore(horaFinalEvento)) {
            return true;
        } else {
            router.push("/login");
            Vue.toasted.error("Sessão Expirada por inatividade.");
            store.dispatch('removePreload');

            return false
        }
    } else {
        return false;
    }
}

Vue.prototype.$baseURL = location.origin.indexOf('localhost') > -1 ? 'http://localhost:53826/api/' :
location.origin.indexOf('desenv') > -1 ?
'http://homologa.comprasnetadm.ba.gov.br/api/' 
: location.origin.indexOf('homologa2') > -1 ?
'https://homologa2.comprasnetadm.ba.gov.br/api/'
: location.origin.indexOf('homologa') > -1 ?
'https://homologa.comprasnetadm.ba.gov.br/api/'
: location.origin.indexOf('treinamento') > -1 ?
'http://treinamento.comprasnetadm.ba.gov.br/api/'
:
'https://www.comprasnetadm.ba.gov.br/api/';

const instance = axios.create({
    baseURL: Vue.prototype.$baseURL,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer ' + store.getters.token
    }
});


instance.interceptors.request.use((config) => {
    const token = store.state.token;
    if (token) {
        config.headers = Object.assign({}, config.headers, {
            Authorization: `Bearer ${token}`
        });
        if (ifAtualizarToken()) {
            config.headers = Object.assign({}, config.headers, {
                atualizarToken: true,
                tokenRefresh: store.getters.tokenRefresh
            });
        }
    }

    if (config.method !== "get") {
        store.dispatch('mostrarPreload');
    }
    return config;
});



instance.interceptors.response.use(function (response) {

    if (response.config.method !== "get") {
        store.dispatch('removePreload');
    }

    if (response.headers.novostokens) {
        let novostokens = JSON.parse(response.headers.novostokens);
        store.commit("setToken", novostokens.token);
        store.commit("setTokenRefresh", novostokens.tokenRefresh);
    }
    return response;
}, function (error) {

    if (error.response.status == 401) {
        router.replace("/login")
    }
    Vue.toasted.error(error.response.data.message);
    store.dispatch('removePreload');
    return Promise.reject(error.response);
});


export default {

    get(url) {
        return instance.get(url);
    },

    post(url, model) {
        return instance.post(url, model);
    },

    put(url, model) {
        return instance.put(url, model);
    },

    delete(url) {
        return instance.delete(url);
    },

    baixarArquivo(arquivo, numCgcFornecedor) {

        const link = document.createElement('a');
        store.dispatch('mostrarPreload');
        var regex = /^(http|https):\/\/[\w-]+(\.[\w-]+)+([\w-.,@?^=%&:/~+#]*[\w-@?^=%&/~+#])?/i;
        if(regex.test(arquivo)) {
            link.href = arquivo;
            link.setAttribute('download', arquivo);
            link.setAttribute('target', "_blank");
            document.body.appendChild(link);
            store.dispatch('removePreload');
            link.click();
            return true;
        }

         numCgcFornecedor = numCgcFornecedor ?  numCgcFornecedor.replace(/[\W_]+/g, '') : null;
         axios({
            url: Vue.prototype.$baseURL + 'arquivo/file/',
            method: 'POST',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.getters.token
            },
            data: {
                file: arquivo,
                numCgcFornecedor: numCgcFornecedor
            },
            responseType: 'blob', // important
        }).then((response) => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            link.href = url;
            link.setAttribute('download', arquivo); //or any other extension
            document.body.appendChild(link);
            store.dispatch('removePreload');
            link.click();
        }).catch(error => {

            store.dispatch('removePreload');
            if (error.response.status == 404) {
                Vue.toasted.error("Arquivo não encontrado.");
            } else {
                Vue.toasted.error("Erro ao baixar arquivo");
            }

        });
    },

    abrirArquivo(arquivo, numCgcFornecedor) {
        const link = document.createElement('a');
        store.dispatch('mostrarPreload');
        var regex = /^(http|https):\/\/[\w-]+(\.[\w-]+)+([\w-.,@?^=%&:/~+#]*[\w-@?^=%&/~+#])?/i;
        link.setAttribute('target', "_blank");
        if(regex.test(arquivo)) {
            link.href = arquivo;
            link.setAttribute('download', arquivo);
            document.body.appendChild(link);
            store.dispatch('removePreload');
            link.click();
            return true;
        }

         numCgcFornecedor = numCgcFornecedor ?  numCgcFornecedor.replace(/[\W_]+/g, '') : null;
         axios({
            url: Vue.prototype.$baseURL + 'arquivo/file/',
            method: 'POST',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.getters.token
            },
            data: {
                file: arquivo,
                numCgcFornecedor: numCgcFornecedor
            },
            responseType: 'blob', // important
        }).then((response) => {

            const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
            link.href = url;
            // link.setAttribute('download', arquivo); //or any other extension
            document.body.appendChild(link);
            store.dispatch('removePreload');
            link.click();
        }).catch(error => {

            store.dispatch('removePreload');
            if (error.response.status == 404) {
                Vue.toasted.error("Arquivo não encontrado.");
            } else {
                Vue.toasted.error("Erro ao baixar arquivo");
            }

        });
    },

    exportarExcel(model, tipo) {
        store.dispatch('mostrarPreload');
        
        var urlTipo = null;
        
        /* 
         * 1 - gera excel de solicitações abertas de fornecedores
         * 2 - gera excel de cadastro de fornecedores
         * 3 - gera excel de solicitações de termo de concordância e veracidade
         * 4 - gera excel do menu de relatórios
         */
        if (tipo === 1) urlTipo = Vue.prototype.$baseURL + 'fornecedor/exportarExcel'
        else if (tipo === 2) urlTipo = Vue.prototype.$baseURL + 'fornecedor/exportarExcelCadastros';
        else if (tipo === 3) urlTipo = Vue.prototype.$baseURL + 'fornecedor/exportarExcelTermo';
        else if (tipo === 4) urlTipo = Vue.prototype.$baseURL + 'fornecedor/exportarExcelRelatorios/' + model.opcaoRelatorioEscolhido;
        
        axios({
            url: urlTipo,
            method: 'POST',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + store.getters.token
            },
            data:model,
            responseType: 'blob', // important
        }).then((response) => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            if ( tipo === 1){
                link.setAttribute('download', "Solicitacao.xlsx"); //or any other extension
            } else if (tipo == 2 ){
                link.setAttribute('download', "Cadastros.xlsx");
            } else if (tipo == 4 ){
                link.setAttribute('download', "Relatorio.xlsx");
            } else {
                link.setAttribute('download', "SolicitacaoTermo.xlsx"); //or any other extension
            }
            document.body.appendChild(link);
            store.dispatch('removePreload');
            link.click();
        }).catch(error => {

            store.dispatch('removePreload');
            if (error.response.status === 404) {
                Vue.toasted.error("Arquivo não encontrado.");
            } else if (error.response.status === 406) {
                Vue.toasted.error("Não existem dados para serem exportados.");
            }else{
                Vue.toasted.error("Erro ao baixar arquivo");
            }

        });
    },
};
